module.exports = __webpack_public_path__ + "img/bg1.b1608e29.png";